import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import useStyles from "./ProfessionalContacts.styles";

const StatusTag = ({ tone, children }) => {
  const classes = useStyles();
  const toneClass =
    {
      valid: classes.tagValid,
      expiring: classes.tagExpiring,
      danger: classes.tagDanger,
      neutral: classes.tagNeutral,
    }[tone] || classes.tagNeutral;

  return <span className={clsx(classes.statusTag, toneClass)}>{children}</span>;
};

StatusTag.propTypes = {
  tone: PropTypes.oneOf(["valid", "expiring", "danger", "neutral"]),
  children: PropTypes.node,
};

StatusTag.defaultProps = {
  tone: "neutral",
};

export default StatusTag;
